'use client';

import { c as _c } from "react/compiler-runtime";
import { AlertTriangle, FileQuestion, FolderOpen, LockKeyhole, LogIn } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { Button } from '@/components/ui/button';
export type WikiRepositoryErrorVariant = 'not-found' | 'access' | 'auth' | 'invalid' | 'error';
type WikiRepositoryNotFoundProps = {
  title?: string;
  message?: string;
  actionLabel?: string;
  variant?: WikiRepositoryErrorVariant;
  onBrowseRepositories?: () => void;
};
const variantIcons = {
  'not-found': FileQuestion,
  'access': LockKeyhole,
  'auth': LogIn,
  'invalid': AlertTriangle,
  'error': AlertTriangle
} satisfies Record<WikiRepositoryErrorVariant, typeof FileQuestion>;
export function WikiRepositoryNotFound(t0) {
  const $ = _c(23);
  const {
    title: t1,
    message: t2,
    actionLabel: t3,
    variant: t4,
    onBrowseRepositories
  } = t0;
  const title = t1 === undefined ? "Repository not found" : t1;
  const message = t2 === undefined ? "The requested repository does not exist or you do not have access to it." : t2;
  const actionLabel = t3 === undefined ? "Browse repositories" : t3;
  const variant = t4 === undefined ? "not-found" : t4;
  const router = useRouter();
  const Icon = variantIcons[variant];
  const ActionIcon = variant === "auth" ? LogIn : FolderOpen;
  let t5;
  if ($[0] !== onBrowseRepositories || $[1] !== router) {
    t5 = () => {
      if (onBrowseRepositories) {
        onBrowseRepositories();
      } else {
        router.push("/wiki");
      }
    };
    $[0] = onBrowseRepositories;
    $[1] = router;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const handleBrowseClick = t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute -inset-2 bg-primary/5 rounded-full blur-md" />;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== Icon) {
    t7 = <div className="relative inline-block mb-3">{t6}<div className="relative flex items-center justify-center w-10 h-10 bg-background rounded-full border border-border/50"><Icon className="h-4 w-4 text-muted-foreground" /></div></div>;
    $[4] = Icon;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== title) {
    t8 = <h3 className="text-base font-medium text-foreground/90">{title}</h3>;
    $[6] = title;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== message) {
    t9 = <p className="text-base text-muted-foreground mt-2 max-w-xs mx-auto text-balance">{message}</p>;
    $[8] = message;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
    t10 = <div className="text-center">{t7}{t8}{t9}</div>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== ActionIcon) {
    t11 = <ActionIcon className="mr-2 h-4 w-4" />;
    $[14] = ActionIcon;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== actionLabel || $[17] !== handleBrowseClick || $[18] !== t11) {
    t12 = <div className="text-center mt-6"><Button onClick={handleBrowseClick} size="default" className="px-4">{t11}{actionLabel}</Button></div>;
    $[16] = actionLabel;
    $[17] = handleBrowseClick;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12) {
    t13 = <div className="w-full max-w-sm mx-auto"><div className="space-y-3">{t10}{t12}</div></div>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}